/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Card,
    CardFromJSON,
    CardToJSON,
    CardWithHistoryDTO,
    CardWithHistoryDTOFromJSON,
    CardWithHistoryDTOToJSON,
    ExtendedCardDTO,
    ExtendedCardDTOFromJSON,
    ExtendedCardDTOToJSON,
    OrderCardDTO,
    OrderCardDTOFromJSON,
    OrderCardDTOToJSON,
    RegisterCardDTO,
    RegisterCardDTOFromJSON,
    RegisterCardDTOToJSON,
    UpdateCardDTO,
    UpdateCardDTOFromJSON,
    UpdateCardDTOToJSON,
} from '../models';

export interface DeleteCardRequest {
    carePrincipalId: string;
    cardSystemId: string;
}

export interface GetAllCardForIdRequest {
    cardId: string;
    carePrincipalId: string;
}

export interface GetAllCardForPersonRequest {
    personId: string;
    carePrincipalId: string;
}

export interface GetCardWithHistoryForPersonRequest {
    carePrincipalId: string;
    personId: string;
    cardTypeId: string;
}

export interface GetCardsAsPdfRequest {
    carePrincipalId: string;
    cardsSystemId: Array<string>;
    careProviderId: string;
    isPdfSummary: boolean;
    patientName: string;
}

export interface GetExtendedCardRequest {
    carePrincipalId: string;
    cardSystemId: string;
}

export interface GetExtendedCardForPersonRequest {
    carePrincipalId: string;
    personId: string;
    cardTypeId: string;
}

export interface OrderCardRequest {
    orderCardDTO: OrderCardDTO;
}

export interface RegisterCardRequest {
    registerCardDTO: RegisterCardDTO;
}

export interface ResetCardRequest {
    carePrincipalId: string;
    cardSystemId: string;
}

export interface UpdateCardRequest {
    updateCardDTO: UpdateCardDTO;
}

/**
 * 
 */
export class CardApi extends runtime.BaseAPI {

    /**
     */
    async deleteCardRaw(requestParameters: DeleteCardRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling deleteCard.');
        }

        if (requestParameters.cardSystemId === null || requestParameters.cardSystemId === undefined) {
            throw new runtime.RequiredError('cardSystemId','Required parameter requestParameters.cardSystemId was null or undefined when calling deleteCard.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/{carePrincipalId}/cardsystemid/{cardSystemId}/deletecard`.replace(`{${"carePrincipalId"}}`, encodeURIComponent(String(requestParameters.carePrincipalId))).replace(`{${"cardSystemId"}}`, encodeURIComponent(String(requestParameters.cardSystemId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteCard(carePrincipalId: string, cardSystemId: string, initOverrides?: RequestInit): Promise<void> {
        await this.deleteCardRaw({ carePrincipalId: carePrincipalId, cardSystemId: cardSystemId }, initOverrides);
    }

    /**
     */
    async getAllCardForIdRaw(requestParameters: GetAllCardForIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ExtendedCardDTO>>> {
        if (requestParameters.cardId === null || requestParameters.cardId === undefined) {
            throw new runtime.RequiredError('cardId','Required parameter requestParameters.cardId was null or undefined when calling getAllCardForId.');
        }

        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling getAllCardForId.');
        }

        const queryParameters: any = {};

        if (requestParameters.cardId !== undefined) {
            queryParameters['cardId'] = requestParameters.cardId;
        }

        if (requestParameters.carePrincipalId !== undefined) {
            queryParameters['carePrincipalId'] = requestParameters.carePrincipalId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/getallcardsforid`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ExtendedCardDTOFromJSON));
    }

    /**
     */
    async getAllCardForId(cardId: string, carePrincipalId: string, initOverrides?: RequestInit): Promise<Array<ExtendedCardDTO>> {
        const response = await this.getAllCardForIdRaw({ cardId: cardId, carePrincipalId: carePrincipalId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllCardForPersonRaw(requestParameters: GetAllCardForPersonRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ExtendedCardDTO>>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling getAllCardForPerson.');
        }

        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling getAllCardForPerson.');
        }

        const queryParameters: any = {};

        if (requestParameters.personId !== undefined) {
            queryParameters['personId'] = requestParameters.personId;
        }

        if (requestParameters.carePrincipalId !== undefined) {
            queryParameters['carePrincipalId'] = requestParameters.carePrincipalId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/getallcardsforperson`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ExtendedCardDTOFromJSON));
    }

    /**
     */
    async getAllCardForPerson(personId: string, carePrincipalId: string, initOverrides?: RequestInit): Promise<Array<ExtendedCardDTO>> {
        const response = await this.getAllCardForPersonRaw({ personId: personId, carePrincipalId: carePrincipalId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCardWithHistoryForPersonRaw(requestParameters: GetCardWithHistoryForPersonRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CardWithHistoryDTO>> {
        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling getCardWithHistoryForPerson.');
        }

        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling getCardWithHistoryForPerson.');
        }

        if (requestParameters.cardTypeId === null || requestParameters.cardTypeId === undefined) {
            throw new runtime.RequiredError('cardTypeId','Required parameter requestParameters.cardTypeId was null or undefined when calling getCardWithHistoryForPerson.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/{carePrincipalId}/person/{personId}/cardtype/{cardTypeId}/card-with-history`.replace(`{${"carePrincipalId"}}`, encodeURIComponent(String(requestParameters.carePrincipalId))).replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))).replace(`{${"cardTypeId"}}`, encodeURIComponent(String(requestParameters.cardTypeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CardWithHistoryDTOFromJSON(jsonValue));
    }

    /**
     */
    async getCardWithHistoryForPerson(carePrincipalId: string, personId: string, cardTypeId: string, initOverrides?: RequestInit): Promise<CardWithHistoryDTO> {
        const response = await this.getCardWithHistoryForPersonRaw({ carePrincipalId: carePrincipalId, personId: personId, cardTypeId: cardTypeId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCardsAsPdfRaw(requestParameters: GetCardsAsPdfRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling getCardsAsPdf.');
        }

        if (requestParameters.cardsSystemId === null || requestParameters.cardsSystemId === undefined) {
            throw new runtime.RequiredError('cardsSystemId','Required parameter requestParameters.cardsSystemId was null or undefined when calling getCardsAsPdf.');
        }

        if (requestParameters.careProviderId === null || requestParameters.careProviderId === undefined) {
            throw new runtime.RequiredError('careProviderId','Required parameter requestParameters.careProviderId was null or undefined when calling getCardsAsPdf.');
        }

        if (requestParameters.isPdfSummary === null || requestParameters.isPdfSummary === undefined) {
            throw new runtime.RequiredError('isPdfSummary','Required parameter requestParameters.isPdfSummary was null or undefined when calling getCardsAsPdf.');
        }

        if (requestParameters.patientName === null || requestParameters.patientName === undefined) {
            throw new runtime.RequiredError('patientName','Required parameter requestParameters.patientName was null or undefined when calling getCardsAsPdf.');
        }

        const queryParameters: any = {};

        if (requestParameters.carePrincipalId !== undefined) {
            queryParameters['carePrincipalId'] = requestParameters.carePrincipalId;
        }

        if (requestParameters.cardsSystemId) {
            queryParameters['cardsSystemId'] = requestParameters.cardsSystemId;
        }

        if (requestParameters.careProviderId !== undefined) {
            queryParameters['careProviderId'] = requestParameters.careProviderId;
        }

        if (requestParameters.isPdfSummary !== undefined) {
            queryParameters['isPdfSummary'] = requestParameters.isPdfSummary;
        }

        if (requestParameters.patientName !== undefined) {
            queryParameters['patientName'] = requestParameters.patientName;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/getCardAsPdf`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async getCardsAsPdf(carePrincipalId: string, cardsSystemId: Array<string>, careProviderId: string, isPdfSummary: boolean, patientName: string, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.getCardsAsPdfRaw({ carePrincipalId: carePrincipalId, cardsSystemId: cardsSystemId, careProviderId: careProviderId, isPdfSummary: isPdfSummary, patientName: patientName }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getExtendedCardRaw(requestParameters: GetExtendedCardRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ExtendedCardDTO>> {
        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling getExtendedCard.');
        }

        if (requestParameters.cardSystemId === null || requestParameters.cardSystemId === undefined) {
            throw new runtime.RequiredError('cardSystemId','Required parameter requestParameters.cardSystemId was null or undefined when calling getExtendedCard.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/{carePrincipalId}/card/{cardSystemId}`.replace(`{${"carePrincipalId"}}`, encodeURIComponent(String(requestParameters.carePrincipalId))).replace(`{${"cardSystemId"}}`, encodeURIComponent(String(requestParameters.cardSystemId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExtendedCardDTOFromJSON(jsonValue));
    }

    /**
     */
    async getExtendedCard(carePrincipalId: string, cardSystemId: string, initOverrides?: RequestInit): Promise<ExtendedCardDTO> {
        const response = await this.getExtendedCardRaw({ carePrincipalId: carePrincipalId, cardSystemId: cardSystemId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getExtendedCardForPersonRaw(requestParameters: GetExtendedCardForPersonRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ExtendedCardDTO>> {
        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling getExtendedCardForPerson.');
        }

        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling getExtendedCardForPerson.');
        }

        if (requestParameters.cardTypeId === null || requestParameters.cardTypeId === undefined) {
            throw new runtime.RequiredError('cardTypeId','Required parameter requestParameters.cardTypeId was null or undefined when calling getExtendedCardForPerson.');
        }

        const queryParameters: any = {};

        if (requestParameters.carePrincipalId !== undefined) {
            queryParameters['carePrincipalId'] = requestParameters.carePrincipalId;
        }

        if (requestParameters.personId !== undefined) {
            queryParameters['personId'] = requestParameters.personId;
        }

        if (requestParameters.cardTypeId !== undefined) {
            queryParameters['cardTypeId'] = requestParameters.cardTypeId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/getextendedcardperson`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExtendedCardDTOFromJSON(jsonValue));
    }

    /**
     */
    async getExtendedCardForPerson(carePrincipalId: string, personId: string, cardTypeId: string, initOverrides?: RequestInit): Promise<ExtendedCardDTO> {
        const response = await this.getExtendedCardForPersonRaw({ carePrincipalId: carePrincipalId, personId: personId, cardTypeId: cardTypeId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async orderCardRaw(requestParameters: OrderCardRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.orderCardDTO === null || requestParameters.orderCardDTO === undefined) {
            throw new runtime.RequiredError('orderCardDTO','Required parameter requestParameters.orderCardDTO was null or undefined when calling orderCard.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/efrikort/client/ordercard`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderCardDTOToJSON(requestParameters.orderCardDTO),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async orderCard(orderCardDTO: OrderCardDTO, initOverrides?: RequestInit): Promise<void> {
        await this.orderCardRaw({ orderCardDTO: orderCardDTO }, initOverrides);
    }

    /**
     */
    async registerCardRaw(requestParameters: RegisterCardRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Card>> {
        if (requestParameters.registerCardDTO === null || requestParameters.registerCardDTO === undefined) {
            throw new runtime.RequiredError('registerCardDTO','Required parameter requestParameters.registerCardDTO was null or undefined when calling registerCard.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/efrikort/client/registercard`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegisterCardDTOToJSON(requestParameters.registerCardDTO),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CardFromJSON(jsonValue));
    }

    /**
     */
    async registerCard(registerCardDTO: RegisterCardDTO, initOverrides?: RequestInit): Promise<Card> {
        const response = await this.registerCardRaw({ registerCardDTO: registerCardDTO }, initOverrides);
        return await response.value();
    }

    /**
     */
    async resetCardRaw(requestParameters: ResetCardRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling resetCard.');
        }

        if (requestParameters.cardSystemId === null || requestParameters.cardSystemId === undefined) {
            throw new runtime.RequiredError('cardSystemId','Required parameter requestParameters.cardSystemId was null or undefined when calling resetCard.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/{carePrincipalId}/cardsystemid/{cardSystemId}/resetcard`.replace(`{${"carePrincipalId"}}`, encodeURIComponent(String(requestParameters.carePrincipalId))).replace(`{${"cardSystemId"}}`, encodeURIComponent(String(requestParameters.cardSystemId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async resetCard(carePrincipalId: string, cardSystemId: string, initOverrides?: RequestInit): Promise<void> {
        await this.resetCardRaw({ carePrincipalId: carePrincipalId, cardSystemId: cardSystemId }, initOverrides);
    }

    /**
     */
    async updateCardRaw(requestParameters: UpdateCardRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Card>> {
        if (requestParameters.updateCardDTO === null || requestParameters.updateCardDTO === undefined) {
            throw new runtime.RequiredError('updateCardDTO','Required parameter requestParameters.updateCardDTO was null or undefined when calling updateCard.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/efrikort/client/updateCard`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCardDTOToJSON(requestParameters.updateCardDTO),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CardFromJSON(jsonValue));
    }

    /**
     */
    async updateCard(updateCardDTO: UpdateCardDTO, initOverrides?: RequestInit): Promise<Card> {
        const response = await this.updateCardRaw({ updateCardDTO: updateCardDTO }, initOverrides);
        return await response.value();
    }

}
